import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { ObjekteService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [ObjekteService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class ObjekteServiceModule {}
